import type { MonitorRecommendList } from '../types';

export const MonitorSuggestService = Symbol('MonitorSuggestService');

export interface MonitorSuggestService {
    getMonitorRecommendList(): Promise<MonitorRecommendList>
}
